// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import '@/router/permission.js';
import Bridge  from './utils/JSbridge'
import 'lib-flexible'
import './assets/styles/reset.css'
import 'vant/lib/index.css'
import bus from './bus'

Vue.prototype.bus = bus
Vue.prototype.$Bridge = Bridge

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js